import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {FileNode} from './clickatell-tree.interface';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import {FlowType} from "../../models/state/Flow";

export function filterAndSortTree(data$: Observable<FileNode[]>, filterText: string = '', flowType?: FlowType): Observable<FileNode[]> {
  const copy: Observable<FileNode[]> = Object.assign(of(), data$);

  return copy.pipe(
    map((TreeData) => filterTree(TreeData, filterText, flowType)),
    map((folders) => filterOnFolders(folders))
  );
}

function alphabeticallyOrder(a: FileNode, b: FileNode): any {
  const nameA = a.path.toUpperCase(); // ignore upper and lowercase
  const nameB = b.path.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  // names must be equal
  return 0;
}

function filterOnFolders(data: FileNode[]): FileNode[] {
  const folders = [];
  const files = [];
  let children = [];
  data.forEach((flow) => {
    if (flow.children) {
      if (!find(children, { id: flow.id })) {
        folders.push(flow);
      }
      const childrenList = [...children, ...flow.children];
      children = uniqBy(childrenList, 'id');
    } else {
      files.push(flow);
    }
  });
  return folders.sort(alphabeticallyOrder).concat(files.sort(alphabeticallyOrder));
}

export function isSearchedPath(fileNode: FileNode, filterText: string): boolean {
  return filterText
    ? fileNode.path && fileNode.path.toLowerCase().indexOf(filterText.toLowerCase()) > -1
    : true;
}

export function filterTree(data: FileNode[], filterText: string, flowType?: FlowType): FileNode[] {
  const newTree = [];
  if (data) {
    for (const path of data) {

      if (path.children) {
        // branch
        const children = filterTree(path.children, filterText, flowType);
        if (children.length > 0) {
          path.children = children;
          newTree.push(path);
        }
      } else {
        // leaf
        if (flowType && flowType !== path.additionalData?.flowType) {
          continue;
        }
        if (isSearchedPath(path, filterText)) {
          newTree.push(path);
        }
      }
    }
  }
  return newTree.sort(alphabeticallyOrder);
}
